export const GET_BANKCARD_LIST = 'GET_BANKCARD_LIST'
export const GET_BANK_NAME_LIST = 'GET_BANK_NAME_LIST'
export const GET_CARD_TYPE_LIST = 'GET_CARD_TYPE_LIST'
export const SET_BANKCARD_LIST = 'SET_BANKCARD_LIST'
export const SET_BANKCARD_LIST_STATE = 'SET_BANKCARD_LIST_STATE'
export const SAVE_BANKCARD_INFO = 'SAVE_BANKCARD_INFO'
export const SELECT_BANKCARD = 'SELECT_BANKCARD'
export const DELETE_BANKCARD_INFO = 'DELETE_BANKCARD_INFO'
export const SET_BANKCARD_LIST_NAME = 'SET_BANKCARD_LIST_NAME'
export const GET_BANKCARD_LIST_NAME = 'GET_BANK_LISTCARD_NAME'

export const GET_REGION_DATA = 'GET_REGION_DATA'
export const SET_PROVINCE_DATA = 'SET_PROVINCE_DATA'
export const SET_CITY_AND_DISTRICT_DATA = 'SET_CITY_AND_DISTRICT_DATA'
export const SET_PROVINCE_STATE = 'SET_PROVINCE_STATE'
export const SET_CITY_AND_DISTRICT_STATE = 'SET_CITY_AND_DISTRICT_STATE'
export const GET_SELECTED_BANK_ID_STATE = 'GET_SELECTED_BANK_ID_STATE'
export const GET_SELECTED_BANK_NO_STATE = 'GET_SELECTED_BANK_NO_STATE'
export const SET_SELECTED_BANK_ID_STATE = 'SET_SELECTED_BANK_ID_STATE'
export const SET_SELECTED_BANK_NO_STATE = 'SET_SELECTED_BANK_NO_STATE'



// WEBPACK FOOTER //
// ./src/vuex/types/common/bankcardList.js